export default "__VITE_ASSET__UdVgQ6ac__"